// v1/v2 compatibility readers for the overloaded `source` field (PRD item 2).
// Mirrors backend/services/finding_compat.py exactly — every consumer (backend
// formatters, XLSX exporter, and these two frontend components) must read
// through the same fallback so v1 and v2 briefings never disagree on display.

const SOURCE_TO_TIMEFRAME = {
  "this week": "this_week",
  "this month": "this_month",
  "this quarter": "this_quarter",
};

export const TIMEFRAME_LABELS = {
  this_week: "This Week",
  this_month: "This Month",
  this_quarter: "This Quarter",
};

export const entityNameOf = (f) => f.entity_name || f.source || null;

export const timeframeOf = (f) => f.timeframe || SOURCE_TO_TIMEFRAME[(f.source || "").toLowerCase()] || null;
